import router from "@/router";
import axios from "axios";

// 根据环境和模式设置 baseURL
const getBaseURL = () => {
  if (process.env.NODE_ENV === "development") {
    return "/local";
  }
  // 生产环境但在本地运行时使用代理
  if (window.location.hostname === "localhost") {
    return "/api";
  }
  // 实际生产环境
  return process.env.VUE_APP_URL;
};

// 清除本地存储的函数
const clearLocalStorage = () => {
  // 清除 localStorage
  localStorage.clear();
  
  // 清除 sessionStorage
  sessionStorage.clear();
  
  // 清除所有 cookies
  document.cookie.split(";").forEach(function(c) { 
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
  });
};

// 安全的路由跳转函数
const safeRouterPush = (routeName) => {
  // 检查当前路由，避免重复导航
  if (router.currentRoute.name !== routeName) {
    router.push({ name: routeName }).catch(err => {
      if (err.name !== 'NavigationDuplicated') {
        console.error('Navigation error:', err);
      }
    });
  }
};

// 显示消息的函数
const showMessage = (message, type = 'error') => {
  // 尝试多种方式显示消息
  if (window.Vue && window.Vue.prototype.$message) {
    window.Vue.prototype.$message[type](message);
  } else if (window.$message) {
    window.$message[type](message);
  } else {
    console.error(message);
  }
};

// 创建 axios 实例
const http = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-source": "web",
  },
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    // 开发环境下打印请求信息
    if (
      process.env.NODE_ENV === "development" ||
      window.location.hostname === "localhost"
    ) {
      console.log("Request:", {
        url: config.url,
        baseURL: config.baseURL,
        method: config.method,
        env: process.env.NODE_ENV,
      });
    }

    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    const res = response;
    if (res.data.code === 200) {
      return res;
    }
    if ([4003, 6003, 6004].includes(res.data.code)) {
      showMessage(res.data.message || "登录已失效，请重新登录");
      
      // 清除所有本地存储
      clearLocalStorage();
      
      // 直接跳转到登录页面
      safeRouterPush("login");
      
      return Promise.reject(res);
    }
    
    showMessage(res.data.message || "请求失败");
    return Promise.reject(res);
  },
  (error) => {
    showMessage(
      error.response?.data?.message || error.data?.message || "服务器异常"
    );
    
    const code = error.response?.data?.code;
    if ([4003, 6003, 6004].includes(code)) {
      // 清除所有本地存储
      clearLocalStorage();
      
      // 直接跳转到登录页面
      safeRouterPush("login");
    }
    
    return Promise.reject(error);
  }
);

export default http;
